export default __webpack_public_path__ + "locales/ar-SA/Translations.json?hash=c7e6599a0188d61071ffb771ade3a9e8";